import Grid from '@mui/material/Grid';
import type { DisplayContextsType } from '@openx/types/targeting/targeting.ts';
import type { TechnologyAndDevicesOption, UserAgentPayload } from '@openx/types/targeting/technologyAndDevices.ts';
import type { JSX } from 'react';
import { DrawerTopBox } from '../shared/TargetingDrawer/DrawerTopBox.tsx';
import { TopBoxValueField } from './TechnologyAndDevicesTopBox/TopBoxValueField.tsx';
import { TypeOptionDropdown } from './TechnologyAndDevicesTopBox/TypeOptionDropdown.tsx';

type TopBoxProps = {
  items: Set<string> | UserAgentPayload;
  onChange: (options: Set<string> | UserAgentPayload) => void;
  selectedType: TechnologyAndDevicesOption;
  onTypeChange: (type: TechnologyAndDevicesOption) => void;
  isNewFormat?: boolean;
  displayContext?: DisplayContextsType;
};

export const TopBox = ({
  items,
  onChange,
  selectedType,
  onTypeChange,
  isNewFormat = true,
  displayContext,
}: TopBoxProps): JSX.Element => {
  return (
    <DrawerTopBox>
      <Grid
        container
        spacing={1}
        sx={{
          alignItems: 'flex-end',
          flexGrow: 1,
        }}
      >
        <Grid size={3}>
          <TypeOptionDropdown
            onChange={onTypeChange}
            value={selectedType}
            isNewFormat={isNewFormat}
            displayContext={displayContext}
          />
        </Grid>

        <Grid size={9}>
          <TopBoxValueField
            items={items}
            onChange={onChange}
            selectedType={selectedType}
            displayContext={displayContext}
          />
        </Grid>
      </Grid>
    </DrawerTopBox>
  );
};
